var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _c("div", { attrs: { id: "subheader" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "main-container" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { attrs: { id: "container" } }, [
          _c(
            "div",
            { attrs: { id: "list-container" } },
            _vm._l(_vm.items, function(item) {
              return _c("item-promocion", {
                attrs: { id: "list-prod", item: item },
                on: { setItemPromocion: _vm.setPromo }
              })
            })
          )
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "btnContainer" } }, [
          _c(
            "button",
            { attrs: { id: "btnIrCarrito" }, on: { click: _vm.btnIrCarrito } },
            [_vm._v("IR AL CARRITO")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePro" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPopup,
                expression: "showPopup"
              }
            ]
          },
          [
            _c("div", { attrs: { id: "back-popup" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "popup" } }, [
              _c("div", { attrs: { id: "popup-btnClose-container" } }, [
                _c("img", {
                  staticStyle: { width: "20px", height: "20px" },
                  attrs: { id: "btnClose", src: "/dist/btnClose.png" },
                  on: { click: _vm.btnCerrarPopup }
                })
              ]),
              _vm._v(" "),
              _c("p", { attrs: { id: "popup-titulo" } }, [
                _vm._v("Ver Promoción")
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "popup-container" } }, [
                _c("div", { attrs: { id: "popup-image-container" } }, [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.imagenProducto != null,
                        expression: "imagenProducto != null"
                      }
                    ],
                    attrs: { id: "imagenProducto", src: _vm.imagenProducto }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: { "margin-top": "20px", color: "#5C666F" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fh lc",
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "600"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.nombrePromo) + " ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lc",
                        staticStyle: {
                          "font-size": "12px",
                          "font-weight": "500"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.descripcionPromo) + " ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lc",
                        staticStyle: {
                          "margin-top": "20px",
                          "font-size": "21px",
                          "font-weight": "500"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.moneyLabel) +
                            _vm._s(_vm._f("formatMoney")(_vm.precioPromo)) +
                            " "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lt",
                        staticStyle: {
                          "margin-top": "20px",
                          width: "210px",
                          "font-size": "14px",
                          "font-weight": "600"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "50%",
                              "font-size": "14px",
                              "font-weight": "400"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh lc",
                                staticStyle: {
                                  "margin-top": "5px",
                                  "font-size": "11px",
                                  "font-weight": "500"
                                }
                              },
                              [_vm._v(" CANTIDAD ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.limitePromo,
                                    expression: "limitePromo"
                                  }
                                ],
                                staticStyle: {
                                  "font-size": "8px",
                                  "font-weight": "400",
                                  color: "#5C666F"
                                }
                              },
                              [
                                _vm._v(
                                  "(max " +
                                    _vm._s(_vm.limiteMaxCantPromo) +
                                    " packs)"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showPesoPromo,
                                    expression: "showPesoPromo"
                                  }
                                ],
                                class: {
                                  popupMaximoPorcentaje: _vm.pesoMinimoOk,
                                  popupMaximoPorcentajeInv: !_vm.pesoMinimoOk
                                }
                              },
                              [
                                _vm._v(
                                  "\n                   Peso minimo: " +
                                    _vm._s(_vm.pesoMinimo) +
                                    "Kg\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showPesoPromo,
                                    expression: "showPesoPromo"
                                  }
                                ],
                                class: {
                                  popupMaximoPorcentaje: _vm.pesoMinimoOk,
                                  popupMaximoPorcentajeInv: !_vm.pesoMinimoOk
                                }
                              },
                              [
                                _vm._v(
                                  "\n                   (Peso actual: " +
                                    _vm._s(
                                      _vm.cantidadProducto * _vm.pesoPromo
                                    ) +
                                    "Kg)\n                "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "50%",
                              "font-size": "14px",
                              "font-weight": "600"
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cantidadProducto,
                                  expression: "cantidadProducto"
                                }
                              ],
                              class: {
                                popupCantidad: _vm.cantValida,
                                popupCantidadInv: !_vm.cantValida
                              },
                              attrs: { type: "text", value: "1" },
                              domProps: { value: _vm.cantidadProducto },
                              on: {
                                keyup: _vm.updateCantidad,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.cantidadProducto = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fv lt",
                                staticStyle: {
                                  "margin-top": "2px",
                                  "font-size": "8px",
                                  "font-weight": "400"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.tieneUnidadDePedido,
                                        expression: "tieneUnidadDePedido"
                                      }
                                    ],
                                    class: {
                                      popupMaximoPorcentaje:
                                        _vm.esMultiploValido,
                                      popupMaximoPorcentajeInv: !_vm.esMultiploValido
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                       (Debe ser múltiplo de " +
                                        _vm._s(_vm.unidadesPorPedido) +
                                        ")\n                   "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.esMultiploValido,
                                        expression: "!esMultiploValido"
                                      }
                                    ],
                                    staticClass: "popupMaximoPorcentajeInv"
                                  },
                                  [
                                    _vm._v(
                                      "\n                       " +
                                        _vm._s(_vm.valorCercano) +
                                        "\n                   "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lc",
                        staticStyle: {
                          "margin-top": "20px",
                          width: "210px",
                          "font-size": "14px",
                          "font-weight": "600"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: {
                              width: "50%",
                              "font-size": "14px",
                              "font-weight": "600"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh lc",
                                staticStyle: {
                                  "font-size": "11px",
                                  "font-weight": "500"
                                }
                              },
                              [_vm._v(" SUBTOTAL ")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: {
                              width: "50%",
                              "font-size": "14px",
                              "font-weight": "600"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh lc",
                                staticStyle: {
                                  "font-size": "13px",
                                  "font-weight": "600"
                                }
                              },
                              [
                                _vm._v(
                                  " \n                      " +
                                    _vm._s(_vm.moneyLabel) +
                                    _vm._s(
                                      _vm._f("formatMoney")(
                                        _vm.cantidadProducto * _vm.precioPromo
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "btnContainerPopup" } }, [
                _c(
                  "button",
                  {
                    attrs: { id: "btnCerrarPopup" },
                    on: { click: _vm.btnCerrarPopup }
                  },
                  [_vm._v("CANCELAR")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: { id: "btnAgregarPopup" },
                    on: { click: _vm.btnAgregarPopup }
                  },
                  [_vm._v("AGREGAR AL CARRITO")]
                )
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Promociones")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a72fee0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a72fee0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promociones/promociones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a72fee0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promociones/promociones.vue
// module chunks = 0